import { NdrRecordEntity } from 'src/store/ndr-record/ndr-record.model';
import { PrdProcessingState } from './pilot-view-model';

export class NdrRecordViewModel implements NdrRecordEntity {
  public id: string;
  public pilotId: string;
  public ndrRequestDate: Date;
  public suppressed: boolean;
  public processingState: PrdProcessingState;
  public processingError: string;
  public lastProcessedDate: Date;
  public prdSourceSystemId: string;

  constructor(ndrRecord: NdrRecordEntity) {
    Object.assign(this, ndrRecord);
  }
}
